import { useState, useEffect } from "react";
import { getCallScript } from "utils/callScriptsApi";

/**
 * Hook to fetch call script questions and create a mapping of question_id -> question_text
 */
export const useQuestionTextMap = (callScriptId: string | null | undefined) => {
  const [questionTextMap, setQuestionTextMap] = useState<Record<string, string>>({});
  const [callScriptName, setCallScriptName] = useState<string | null>(null);

  useEffect(() => {
    if (!callScriptId) {
      setQuestionTextMap({});
      setCallScriptName(null);
      return;
    }

    const fetchQuestions = async () => {
      try {
        const callScript = await getCallScript(callScriptId);
        const map: Record<string, string> = {};

        callScript.questions.forEach((question) => {
          map[question.id] = question.question_text;
        });

        setQuestionTextMap(map);
        setCallScriptName(callScript.name ?? null);
      } catch (err: any) {
        console.error("Error fetching call script questions:", err);
        // On error, set empty map - custom answers will filter out rows without question text
        setQuestionTextMap({});
        setCallScriptName(null);
      }
    };

    fetchQuestions();
  }, [callScriptId]);

  return { questionTextMap, callScriptName };
};
